<template>
  <div class="view subject-results">
    <CaseDashboard></CaseDashboard>
  </div>
</template>

<script>
import CaseDashboard from '@/components/CaseDashboard/CaseDashboard'
export default {
  name: 'SubjectResultsView',
  components: {
    CaseDashboard
  }
}
</script>

<style lang="stylus" scoped>
// .subject-results
  // display: flex
  // overflow visible !important //Para el tooltip del ECG (parace que ok...)
</style>
